import getLocalId from 'modules/redux/utils/get-local-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function getIdReduxUtil (instance) {
  if (!instance) {
    return
  }
  return (
    getValueReduxUtil(instance, 'id') ||
    getLocalId(instance)
  )
}

export default getIdReduxUtil
